export default {
  customerDatabase: 'Database Customer',
  searchText: 'Cari Nama Customer',
  customer: 'Customer',
  address: 'Alamat',
  contact: 'Kontak',
  phoneNumber: 'No Telpon',
  contractDuration: 'Durasi Kontrak',
  editContract: 'Ubah Kontrak',
  createContract: 'Buat Kontrak',
  companyInfo: 'Informasi Perusahaan',
  contractInfo: 'Informasi Kontrak',
  adminInfo: 'Informasi Admin',
  locationVehicleDatabase: 'Database Lokasi dan Kendaraan',
  priceSetting: 'Pengaturan Harga',
  // form
  companyName: 'Nama Perusahaan',
  companyNamePlaceholder: 'diisi sesuai nama perusahaan di kartu NPWP',
  abbreviation: 'Alias/inisial',
  companyAddress: 'Alamat Perusahaan',
  // urbanVillage: 'Kelurahaan',
  subDistrict: 'Kelurahan',
  district: 'Kecamatan',
  city: 'Kodya/Kab',
  province: 'Provinsi',
  postalCode: 'Kode Pos',
  billingAddress: 'Alamat Penagihan',
  companyPhoneNumber: 'No telp Perusahaan',
  companyEmail: 'Email Perusahaan',
  office: 'Kantor',
  fax: 'Fax',
  npwpNo: 'No NPWP',
  npwpAddressPlaceholder: 'sesuai alamat pada kartu NPWP',
  npwpAddress: 'Alamat NPWP',
  pkpNo: 'No PKP',
  presidentName: 'Nama Pimpinan',
  companyService: 'Produk / Jasa Perusahaan',
  siupNo: 'No SIUP',
  tdpNo: 'No TDP',
  companyEstablishedYear: 'Tahun Berdiri Perusahaan',

  contractNo: 'No Kontrak',
  contractNoPlaceholder: 'sesuai nomor pada kontrak perjanjian',
  contractPeriod: 'Lama Masa Kerja / Kontrak',
  start: 'Mulai',
  until: 'sampai',
  end: 'Berakhir',
  termOfPayment: 'Term of Payment',
  paymentMethod: 'Metode Pembayaran via Transfer',
  otherpaymentMethod: 'Metode Pembayaran Lain',
  paymentPicName: 'Nama PIC Pembayaran',
  paymentPicPhoneNo: 'No Telpon PIC Pembayaran',
  operationalPicName: 'Nama PIC Operasional',
  operationalPicPhoneNo: 'No Telpon PIC Operasional',
  clientInsurance: 'Klien Menggunakan Asuransi',
  financeReportAudited: 'Laporan Keuangan diaudit KAP',
  averageValuePerShipment: 'Average Value per Shipment',
  assetTotal: 'Total Asset',
  ventureCapital: 'Modal Usaha',
  salesTotal: 'Total Penjualan',
  shareHolder: 'Pemegang Saham',
  bankName: 'Nama Bank',
  bankAccountName: 'Nama Pemilik Rekening',
  bankAccountNo: 'Nomor Rekening',
  typeOfServiceUsed: 'Jenis Jasa yang Digunakan',
  fliIntegratedService: 'FLI Integrated Service',
  fliTransportation: 'FLI Transportation',
  fliWarehousing: 'FLI Warehousing',
  fliEnableMultiShipper: 'Multishipper',
  others: 'Lain - Lain',
  admin: 'Admin',
  showUserListDialogButtonLabel: 'lihat daftar user',
}
